import {

    RESET_MESSAGE,
    EDIT_DELETE_USER_FAILURE,
    GET_USER_LIST_SUCCESS,
    GET_USER_LIST_FAILURE,
    GET_USER_LIST_PROGRESS,
    ADD_USER_PROGRESS,
    ADD_USER_SUCCESS,
    ADD_USER_FAILURE,
    EDIT_DELETE_USER_PROGRESS,
    EDIT_DELETE_USER_SUCCESS,

} from '../../types/actionTypes';

const initialState = {
    user: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const user_reducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_USER_LIST_SUCCESS:
            return { ...state, user: action.user, loading: false };
        case GET_USER_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_USER_LIST_PROGRESS:
            return { ...state, loading: true, error: false };

        case ADD_USER_PROGRESS:
            return { ...state, loading: true };
        case ADD_USER_SUCCESS:
            return { ...state, user: [...state.user, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_USER_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case EDIT_DELETE_USER_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_USER_SUCCESS:
            return {
                ...state,
                user: state.user.map((user) =>
                    user.id === action.payload.id ? action.payload : user
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_USER_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case RESET_MESSAGE:
            return { ...state, message: null };

        default:
            return state
    }
}

export default user_reducer;